import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { apiUrl } from "../../../config/config.js";

const Toast = Swal.mixin({
	toast: true,
	position: "top-end",
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.onmouseenter = Swal.stopTimer;
		toast.onmouseleave = Swal.resumeTimer;
	},
});

function PaymentsDetails() {
	const location = useLocation();
	const navigate = useNavigate();
	const type = location.state?.type || "";
	const data = useMemo(() => location.state?.data || [], [location.state]);
	const [itemId, setItemId] = useState("");
	const [userId, setUserId] = useState("");
	const [reservationId, setReservationId] = useState("");
	const [description, setDescription] = useState("");
	const [status, setStatus] = useState("pending");
	const [amount, setAmount] = useState("");
	const [currency, setCurrency] = useState("");
	const [transactionHash, setTransactionHash] = useState("");
	const [addressFrom, setAddressFrom] = useState("");
	const [addressTo, setAddressTo] = useState("");
	const [paymentGateway, setPaymentGateway] = useState("");

	useEffect(() => {
		if (type === "edit" && data) {
			setItemId(data.ID || "");
			setUserId(data["ID Usuario"] || "");
			setReservationId(data["ID Reservación"] || "");
			setDescription(data["Descripción"] || "");
			setStatus(data.Estado || "pending");
			setAmount(data.Monto || "");
			setCurrency(data.Moneda || "");
			setTransactionHash(data["Hash Transacción"] || "");
			setAddressFrom(data["Dirección Origen"] || "");
			setAddressTo(data["Dirección Destino"] || "");
			setPaymentGateway(data["Pasarela de Pago"] || "");
		}
	}, [type, data]);

	const validateForm = () => {
		if (!userId || !reservationId || !description || !amount || !currency) {
			Toast.fire({
				icon: "error",
				title: "Todos los espacios son requeridos",
				background: "#1e2836",
			});
			return false;
		}
		return true;
	};

	const handleSubmit = async (event, action = null) => {
		event.preventDefault();
		if (!validateForm()) return;
		try {
			const response = await fetch(apiUrl + "/actions", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					action: type === "add" ? "create" : action === null ? "update" : action,
					table: "payments",
					data: {
						id: itemId,
						userId,
						reservationId,
						description,
						status,
						amount,
						currency,
						transactionHash,
						addressFrom,
						addressTo,
						paymentGateway,
					},
				}),
			});
			const responseData = await response.json();
			if (responseData.ok) {
				Toast.fire({
					icon: "success",
					title: responseData.message,
					background: "#1e2836",
					color: "#fff",
				});
				window.history.back();
			} else {
				Toast.fire({
					icon: "error",
					title: response.message,
					color: "#fff",
					background: "#1e2836",
				});
				throw new Error(responseData.message || "Error al enviar data");
			}
		} catch (error) {
			Toast.fire({
				icon: "error",
				title: error.message,
				background: "#1e2836",
				color: "#fff",
			});
		}
	};

	return (
		<div>
			<form onSubmit={handleSubmit}>
				<h1 className="text-center">{type === "add" ? "Agregar Pago" : "Actualizar Pago"}</h1>
				<div className="mb-3">
					<label className="form-label">
						ID Usuario <span className="text-danger">*</span>
					</label>
					<input
						type="text"
						className="form-control form-control-lg bg-white bg-opacity-5"
						value={userId}
						onChange={(e) => setUserId(e.target.value)}
					/>
				</div>
				<div className="mb-3">
					<label className="form-label">
						ID Reservación <span className="text-danger">*</span>
					</label>
					<input
						type="text"
						className="form-control form-control-lg bg-white bg-opacity-5"
						value={reservationId}
						onChange={(e) => setReservationId(e.target.value)}
					/>
				</div>
				<div className="mb-3">
					<label className="form-label">
						Descripción <span className="text-danger">*</span>
					</label>
					<input
						type="text"
						className="form-control form-control-lg bg-white bg-opacity-5"
						value={description}
						onChange={(e) => setDescription(e.target.value)}
					/>
				</div>
				<div className="mb-3">
					<label className="form-label">
						Estado <span className="text-danger">*</span>
					</label>
					<select className="form-select form-control-lg bg-white bg-opacity-5" value={status} onChange={(e) => setStatus(e.target.value)}>
						<option value="pending">Pendiente</option>
						<option value="paid">Pagado</option>
					</select>
				</div>
				<div className="mb-3">
					<label className="form-label">
						Monto <span className="text-danger">*</span>
					</label>
					<input
						type="number"
						className="form-control form-control-lg bg-white bg-opacity-5"
						value={amount}
						onChange={(e) => setAmount(e.target.value)}
					/>
				</div>
				<div className="mb-3">
					<label className="form-label">
						Moneda <span className="text-danger">*</span>
					</label>
					<input
						type="text"
						className="form-control form-control-lg bg-white bg-opacity-5"
						value={currency}
						onChange={(e) => setCurrency(e.target.value)}
					/>
				</div>
				<div className="mb-3">
					<label className="form-label">Hash Transacción</label>
					<input
						type="text"
						className="form-control form-control-lg bg-white bg-opacity-5"
						value={transactionHash}
						onChange={(e) => setTransactionHash(e.target.value)}
					/>
				</div>
				<div className="mb-3">
					<label className="form-label">Dirección Origen</label>
					<input
						type="text"
						className="form-control form-control-lg bg-white bg-opacity-5"
						value={addressFrom}
						onChange={(e) => setAddressFrom(e.target.value)}
					/>
				</div>
				<div className="mb-3">
					<label className="form-label">Dirección Destino</label>
					<input
						type="text"
						className="form-control form-control-lg bg-white bg-opacity-5"
						value={addressTo}
						onChange={(e) => setAddressTo(e.target.value)}
					/>
				</div>
				<div className="mb-3">
					<label className="form-label">Pasarela de Pago</label>
					<input
						type="text"
						className="form-control form-control-lg bg-white bg-opacity-5"
						value={paymentGateway}
						onChange={(e) => setPaymentGateway(e.target.value)}
					/>
				</div>

				<div className="mb-3 d-flex justify-content-around ">
					<button type="submit" className="btn btn-outline-theme btn-lg">
						{type === "add" ? "Agregar" : "Actualizar"}
					</button>
					<button onClick={() => navigate("/payments")} className="btn btn-outline-theme btn-lg">
						Atrás
					</button>
					<button
						onClick={(event) => {
							handleSubmit(event, "delete");
						}}
						className="btn btn-outline-danger btn-lg">
						Eliminar
					</button>
				</div>
			</form>
		</div>
	);
}

export default PaymentsDetails;
